module.exports = __webpack_public_path__ + "img/xiuzheng.684860a5.svg";